import { Component,ElementRef,HostListener, ViewChild } from '@angular/core';
import { Router, RouterModule } from '@angular/router';


@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent {

  @ViewChild('navbarContent', { static: false }) navbarContent!: ElementRef;

  productsList = [
    {name:'Ripple Build', test:'dummy test'},
    {name:'Ripple Care', test:'dummy test'},
    {name:'Ripple Warehousing services', test:'dummy test'},
  
  ];
  serviceList = [
    {name:'Development platforms', test:'dummy text'},
    {name:'SEO', test:'dummy text'},
    {name:'Customer notifications', test:'dummy text'},
  
  ];
  productsList1 = [
    {name:'Ripple Flash', test:'Same day delovery in metros'},
    // {name:'Ripple Assist', test:'WhatsApp and Emails'},
    {name:'Ripple Assist Adv', test:'Call center support'},

  ];
  serviceList1 = [
    {name:'Payment plans and COD and change', test:'dummy text'}, 
    // {name:'Ripple assist', test:'dummy text'},

  ];
  productsList2 = [
    {name:'Ripple Boost', test:'Marketing and ads support'},
    // {name:'Ripple Trust', test:'Returns management and AI assist'},
    {name:'Ripple influence', test:'dummy text'},
  ];
  ondcList = [
    {name:'Platforms integrated with journey', test:'dummy text'},
    {name:'Sales increment plans', test:'dummy text'},
  ];
  partnerList = [
    {name:'Development partners', test:'dummy text'},
    {name:'Shipping partners', test:'dummy text'},
    {name:'Marketting partners', test:'dummy text'},

  ];


  constructor(private router :Router) { 
    
  }

  isScrolled = false;

  @HostListener('window:scroll', ['$event'])
  onScroll(event: Event): void {
    // Calculate the scroll position to determine when to change the background color
    const scrollPosition = window.scrollY || window.pageYOffset;
    this.isScrolled = scrollPosition > 100; // Adjust the scroll offset as needed
  }

  scrollTOView(){

    window.scrollTo(0, 0);
    
  }
  onClick(){
    
    let hom=window.location.href
    console.log(hom)
    
    if(hom.search('home')!=-1)
    
    window.scrollTo(0, 0);
    
    else{
    
    this.router.navigate(['/track-order']);
    

    setTimeout(()=>{
    
    this.scrollTOView();
    
    },800)
    
    } 
  }
  scrollTOView6(){

    window.scrollTo(0, 2);
    
  }
  scrollTOView1(){

    window.scrollTo(0, 2);
    
  }
  scrollTOView2(){

    window.scrollTo(0, 2);
    
  }
  scrollTOView3(){

    window.scrollTo(0, 2);
    
  }
  scrollTOView4(){

    window.scrollTo(0, 2);
    
  }
  scrollTOView5(){

    window.scrollTo(0, 2);
    
  }
  onClick6(){
    
    let hom=window.location.href
    console.log(hom)
    
    if(hom.search('home')!=-1)
    
    window.scrollTo(0, 2);
    
    else{
    
    this.router.navigate(['/partners']);
    

    setTimeout(()=>{
    
    this.scrollTOView6();
    
    },800)
    
    } 
  }

  onClick1(){
    
    let hom=window.location.href
    console.log(hom)
    
    if(hom.search('home')!=-1)
    
    window.scrollTo(0, 2);
    
    else{
    
    this.router.navigate(['/track-order']);
    

    setTimeout(()=>{
    
    this.scrollTOView1();
    
    },800)
    
    } 
  }

  
  onClick2(){
    
    let hom=window.location.href
    console.log(hom)
    
    if(hom.search('home')!=-1)
    
    window.scrollTo(0, 2);
    
    else{
    
    this.router.navigate(['/services']);
    

    setTimeout(()=>{
    
    this.scrollTOView2();
    
    },800)
    
    } 
  }

  onClick3(){
    
    let hom=window.location.href
    console.log(hom)
    
    if(hom.search('home')!=-1)
    
    window.scrollTo(0, 2);
    
    else{
    
    this.router.navigate(['/new-pricing']);
    

    setTimeout(()=>{
    
    this.scrollTOView3();
    
    },800)
    
    } 
  }
  onClick4(){
    
    let hom=window.location.href
    console.log(hom)
    
    if(hom.search('home')!=-1)
    
    window.scrollTo(0, 2);
    
    else{
    
    this.router.navigate(['/contacts']);
    

    setTimeout(()=>{
    
    this.scrollTOView4();
    
    },800)
    
    } 
  }

  onClick5(){
    
    let hom=window.location.href
    console.log(hom)
    
    if(hom.search('home')!=-1)
    
    window.scrollTo(0, 2);
    
    else{
    
    this.router.navigate(['/partners']);
    

    setTimeout(()=>{
    
    this.scrollTOView5();
    
    },800)
    
    } 
  }
  toggleMenu() {
    document.getElementById('navbarSupportedContent')?.classList.toggle('show');
    const element = this.navbarContent.nativeElement;
    element.classList.toggle('show');
    this.isScrolled = !this.isScrolled;
  }

  openDropdown: string | null = null;


  openDropdownMenu(menu: string) {
    this.openDropdown = menu;
  }

  closeDropdown() {
    this.openDropdown = null;
  }

  onClick10(){
    
    let hom=window.location.href
    console.log(hom)
    
    if(hom.search('home')!=-1)
    
    window.scrollTo(0, 2);
    
    else{
    
    this.router.navigate(['/ondc']);
    

    setTimeout(()=>{
    
    this.scrollTOView3();
    
    },800)
    
    } 
  }

  onClick11(){
    
    let hom=window.location.href
    console.log(hom)
    
    if(hom.search('home')!=-1)
    
    window.scrollTo(0, 2);
    
    else{
    
    this.router.navigate(['/about']);
    

    setTimeout(()=>{
    
    this.scrollTOView3();
    
    },800)
    
    } 
  }

  route_home(){
    this.router.navigate(['/'])
  }
  
  route(){
    this.router.navigate(['/auth/login'])
  }
  

}
